import { render, staticRenderFns } from "./HelpBubble.vue?vue&type=template&id=71287204&scoped=true&"
import script from "./HelpBubble.vue?vue&type=script&lang=js&"
export * from "./HelpBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71287204",
  null
  
)

export default component.exports